import { Component } from '@angular/core';
import { Router } from '@angular/router';
// import { ModalController } from '@ionic/angular';
import { PopoverController } from '@ionic/angular';

@Component({
	selector: 'popover-feed-component',
	templateUrl: 'popover-feed.html',
	styleUrls:['./popover-feed.scss']
})
export class PopoverFeedComponent {
	constructor(private viewCtrl: PopoverController, private router:Router) {

	}

	onEntrySelect(entry) {
		this.viewCtrl.dismiss(entry);
	}
}
